module.exports = __webpack_public_path__ + "img/Envelope.6c708781.png";